import { FlordersTO } from '../../../interfaces/florders.interface';

const response: FlordersTO = {
  items: [
    {
      orderDate: '2017-10-18',
      etmOrderNumber: '0100003819',
      salesOrderNumber: '0200001123',
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: '222',
      senderRefNumber: null,
      from: { id: 'BE11_001', name: 'Katelijne' },
      to: { id: '0002000220', name: 'Aardappelhandel De Rop N.V.' },
      requestedUnloadingDate: '2017-10-26',
      confirmedUnloadingDate: '2017-10-26',
      transport: 'Z1',
      incoterm: '',
      globalType: 'OUT',
      orderType: 'EPS-CUS',
      orderStatus: '01',
      hasChanged: null,
      updateTime: '',
      updateDate: '',
      updateBy: '',
      ccr: { ccrNumber: null, sealNumber: null, approved: null, ccrLineItems: [] },
    },
    {
      orderDate: '2017-10-10',
      etmOrderNumber: '0100003771',
      salesOrderNumber: '0200001120',
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'erere',
      senderRefNumber: null,
      from: { id: 'BE11_001', name: 'Katelijne' },
      to: { id: '0002000220', name: 'Aardappelhandel De Rop N.V.' },
      requestedUnloadingDate: '2017-10-18',
      confirmedUnloadingDate: '2017-10-18',
      transport: 'Z2',
      incoterm: '',
      globalType: 'OUT',
      orderType: 'EPS-CUS',
      orderStatus: '01',
      hasChanged: null,
      updateTime: '',
      updateDate: '',
      updateBy: '',
      ccr: { ccrNumber: null, sealNumber: null, approved: null, ccrLineItems: [] },
    },
    {
      orderDate: '2017-10-10',
      etmOrderNumber: '0100003770',
      salesOrderNumber: '0300001158',
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'Test for Pieter',
      senderRefNumber: null,
      from: { id: '0002000220', name: 'Aardappelhandel De Rop N.V.' },
      to: { id: 'BE11_001', name: 'Katelijne' },
      requestedUnloadingDate: '2017-11-10',
      confirmedUnloadingDate: '2017-11-10',
      transport: 'Z1',
      incoterm: '',
      globalType: 'IN',
      orderType: 'CUS-EPS',
      orderStatus: '07',
      hasChanged: null,
      updateTime: '',
      updateDate: '',
      updateBy: '',
      ccr: { ccrNumber: '0400000046', sealNumber: '12345', approved: 'Accepted', ccrLineItems: [] },
    },
    {
      orderDate: '2017-10-10',
      etmOrderNumber: '0100003769',
      salesOrderNumber: '0300001157',
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'Test for Pieter',
      senderRefNumber: null,
      from: { id: '0002000220', name: 'Aardappelhandel De Rop N.V.' },
      to: { id: 'BE11_001', name: 'Katelijne' },
      requestedUnloadingDate: '2017-11-10',
      confirmedUnloadingDate: '2017-11-10',
      transport: 'Z1',
      incoterm: '',
      globalType: 'IN',
      orderType: 'CUS-EPS',
      orderStatus: '09',
      hasChanged: null,
      updateTime: '',
      updateDate: '',
      updateBy: '',
      ccr: {
        ccrNumber: '0400000045',
        sealNumber: '12345',
        approved: 'Open',
        ccrLineItems: [],
      },
    },
    {
      orderDate: '2017-10-10',
      etmOrderNumber: '0100003767',
      salesOrderNumber: '0300001156',
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'Test for Pieter',
      senderRefNumber: null,
      from: { id: '0002000220', name: 'Aardappelhandel De Rop N.V.' },
      to: { id: 'BE11_001', name: 'Katelijne' },
      requestedUnloadingDate: '2017-11-10',
      confirmedUnloadingDate: '2017-11-10',
      transport: 'Z1',
      globalType: 'IN',
      orderType: 'CUS-EPS',
      orderStatus: '09',
      hasChanged: null,
      updateTime: '',
      updateDate: '',
      updateBy: '',
      ccr: { ccrNumber: '0400000044', sealNumber: '2134', approved: 'Open', ccrLineItems: [] },
    },
    {
      orderDate: '2017-10-10',
      etmOrderNumber: '0100003766',
      salesOrderNumber: '0300001155',
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'Test for Pieter',
      senderRefNumber: null,
      from: { id: '0002000220', name: 'Aardappelhandel De Rop N.V.' },
      to: { id: 'BE11_001', name: 'Katelijne' },
      requestedUnloadingDate: '2017-11-10',
      confirmedUnloadingDate: '2017-11-10',
      transport: 'Z1',
      globalType: 'IN',
      orderType: 'CUS-EPS',
      orderStatus: '01',
      hasChanged: null,
      updateTime: '',
      updateDate: '',
      updateBy: '',
      ccr: { ccrNumber: null, sealNumber: null, approved: null, ccrLineItems: [] },
    },
    {
      orderDate: '2017-10-10',
      etmOrderNumber: '0100003765',
      salesOrderNumber: '0300001154',
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'Test for Pieter',
      senderRefNumber: null,
      from: { id: '0002000220', name: 'Aardappelhandel De Rop N.V.' },
      to: { id: 'BE11_001', name: 'Katelijne' },
      requestedUnloadingDate: '2017-11-10',
      confirmedUnloadingDate: '2017-11-10',
      transport: 'Z1',
      globalType: 'IN',
      orderType: 'CUS-EPS',
      orderStatus: '01',
      hasChanged: null,
      updateTime: '',
      updateDate: '',
      updateBy: '',
      ccr: { ccrNumber: null, sealNumber: null, approved: null, ccrLineItems: [] },
    },
    {
      orderDate: '2017-10-10',
      etmOrderNumber: '0100003764',
      salesOrderNumber: '0300001153',
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'Test for Pieter',
      senderRefNumber: null,
      from: { id: '0002000220', name: 'Aardappelhandel De Rop N.V.' },
      to: { id: 'BE11_001', name: 'Katelijne' },
      requestedUnloadingDate: '2017-11-10',
      confirmedUnloadingDate: '2017-11-10',
      transport: 'Z1',
      globalType: 'IN',
      orderType: 'CUS-EPS',
      orderStatus: '01',
      hasChanged: null,
      updateTime: '',
      updateDate: '',
      updateBy: '',
      ccr: { ccrNumber: null, sealNumber: null, approved: null, ccrLineItems: [] },
    },
    {
      orderDate: '2017-10-10',
      etmOrderNumber: '0100003763',
      salesOrderNumber: '0300001152',
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'Test for Pieter',
      senderRefNumber: null,
      from: { id: '0002000220', name: 'Aardappelhandel De Rop N.V.' },
      to: { id: 'BE11_001', name: 'Katelijne' },
      requestedUnloadingDate: '2017-11-10',
      confirmedUnloadingDate: '2017-11-10',
      transport: 'Z1',
      globalType: 'IN',
      orderType: 'CUS-EPS',
      orderStatus: '09',
      hasChanged: null,
      updateTime: '',
      updateDate: '',
      updateBy: '',
      ccr: { ccrNumber: '0400000043', sealNumber: '2134', approved: 'Open', ccrLineItems: [] },
    },
    {
      orderDate: '2017-10-10',
      etmOrderNumber: '0100003762',
      salesOrderNumber: '0300001151',
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'Test for Pieter',
      senderRefNumber: null,
      from: { id: '0002000220', name: 'Aardappelhandel De Rop N.V.' },
      to: { id: 'BE11_001', name: 'Katelijne' },
      requestedUnloadingDate: '2017-11-10',
      confirmedUnloadingDate: '2017-11-10',
      transport: 'Z1',
      globalType: 'IN',
      orderType: 'CUS-EPS',
      orderStatus: '01',
      hasChanged: null,
      updateTime: '',
      updateDate: '',
      updateBy: '',
      ccr: { ccrNumber: null, sealNumber: null, approved: null, ccrLineItems: [] },
    },
  ],
  totalItems: 191,
};

export default response;
